import React from 'react';
import { injectIntl, type WrappedComponentProps } from 'react-intl';
import { IconButton } from '@eventbrite/legacy-eds.icon-button';
import { LogoFacebook } from '@eventbrite/legacy-eds.iconography';
import { FACEBOOK_AFFILIATED_CODE } from './constants';
import { openUrl } from './utils';
import type { UtmOptions } from './types';

const FACEBOOK_URL = 'https://www.facebook.com/dialog/share';

const _getEventUrl = (eventUrl: string, affiliateChannel: string, utmOptions: UtmOptions) => {
    const url = new URL(eventUrl);
    url.searchParams.set(
        'aff',
        FACEBOOK_AFFILIATED_CODE[affiliateChannel] || FACEBOOK_AFFILIATED_CODE['default'],
    );

    Object.entries(utmOptions).forEach(([key, value]) => {
        url.searchParams.set(key, value);
    });

    return url.toString();
};

interface FacebookShareProps {
    resourceId: string;
    resourceUrl: string;
    resourceType: string;
    facebookOptions: {
        appId: string;
        locale: string;
    };
    onClick?: () => void;
    utmOptions?: UtmOptions;
    affiliateChannel?: string;
    dataHeapId?: string;
    shareMethod?: string;
    dataPageArea?: string;
    className?: string;
}

class FacebookShareComponent extends React.Component<
    FacebookShareProps & WrappedComponentProps<'intl'>
> {
    _handleButtonClick() {
        const {
            affiliateChannel,
            resourceUrl,
            facebookOptions: { appId, locale },
            onClick,
            utmOptions,
        } = this.props;

        const url = new URL(FACEBOOK_URL);
        url.searchParams.set('locale', locale);
        url.searchParams.set('app_id', appId);
        url.searchParams.set('display', 'popup');
        url.searchParams.set(
            'href',
            _getEventUrl(resourceUrl, affiliateChannel || '', utmOptions || {}),
        );

        if (onClick) {
            onClick();
        }

        openUrl(url.toString());
    }

    render() {
        const { intl } = this.props;
        return (
            <span
                className={this.props.className}
                data-testid="facebook-share-box-container"
                data-heap-id={this.props.dataHeapId}
                data-share-method={this.props.shareMethod}
                data-page-area={this.props.dataPageArea}
                {...{
                    [`data-${this.props.resourceType}-id`]: this.props.resourceId,
                }}
            >
                <IconButton
                    iconType={<LogoFacebook />}
                    title={intl.formatMessage({
                        id: 'Share on Facebook',
                        defaultMessage: 'Share on Facebook',
                    })}
                    onClick={this._handleButtonClick.bind(this)}
                />
            </span>
        );
    }
}

export const FacebookShare = injectIntl(FacebookShareComponent);
